import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.css, "walletButton p-4 text-center cursor-pointer text-sm"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click($event)))
  }, _toDisplayString(this.text), 3))
}